import { useEffect, useState, useRef } from 'react';
import { observer } from 'mobx-react';
import { motion, AnimatePresence } from 'framer-motion';
import MiniCartProduct from './MiniCartProduct';
import wooCommerceStore from '@/stores/woocommerceStore';

const CartNotification = observer(() => {
  const [isVisible, setIsVisible] = useState(false);
  const timeoutRef = useRef(null);

  useEffect(() => {
    const handleCartChange = () => {
      const item = wooCommerceStore.lastModifiedItem;
      const type = wooCommerceStore.lastModificationType;
      const cartOpen = wooCommerceStore.isCartOpen;
      if (item && (type === 'add' || type === 'update') && type !== 'clear' && !cartOpen) {
        // Clear any existing timeout
        if (timeoutRef.current) {
          clearTimeout(timeoutRef.current);
        }

        setIsVisible(true);

        // Set new timeout
        timeoutRef.current = setTimeout(() => {
          setIsVisible(false);
        }, 3000);
      }
    };

    // Listen for cart changes
    const unsubscribe = wooCommerceStore.subscribeToCart(handleCartChange);

    return () => {
      // Clean up timeout and subscription on unmount
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
      if (unsubscribe) unsubscribe();
    };
  }, []);

  const item = wooCommerceStore.lastModifiedItem;
  const type = wooCommerceStore.lastModificationType;
  const cartOpen = wooCommerceStore.isCartOpen;

  const shouldShow = isVisible && item && type !== 'remove' && type !== 'clear' && !cartOpen;

  return (
    <AnimatePresence>
      {shouldShow && (
        <motion.div
          key="cart-notification"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 20 }}
          transition={{ duration: 0.2 }}
          className="absolute top-16 lg:top-30 right-0 rtl:left-0 rtl:right-auto bg-white rounded-lg shadow-lg min-w-[340px] z-50 border border-gray-200 cursor-pointer hover:shadow-xl transition-shadow"
          onClick={() => wooCommerceStore.toggleCart()}
          role="button"
          tabIndex={0}
          onKeyPress={(e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              wooCommerceStore.toggleCart();
            }
          }}
        >
          <MiniCartProduct item={item} notification />
        </motion.div>
      )}
    </AnimatePresence>
  );
});

export default CartNotification;